import api from '../services/api';
import { IFinancialPlan } from '../shared/interfaces';

interface IResponseGetFinancialPlans {
  data: IFinancialPlan[];
  count: number;
}
export const getFinancialPlans = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetFinancialPlans> => {
  const response = await api.post('/financials-plans/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postFinancialPlan = async (
  payload: any,
): Promise<IFinancialPlan> => {
  const response = await api.post(`/financials-plans`, payload);
  return response.data;
};

export const patchFinancialPlan = async (
  id: string | undefined,
  payload: any,
): Promise<IFinancialPlan> => {
  if (!id) {
    throw new Error('ID do plano de contas não fornecido.');
  }
  const response = await api.patch(`/financials-plans/${id}`, payload);
  return response.data;
};

export const getSelectFinancialPlans = async (): Promise<IFinancialPlan[]> => {
  const response = await api.get(`/financials-plans/select/all`);
  return response.data;
};
